import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 0h60v40H0z",
  style: {"fill":"#009246","fill-opacity":"1","stroke":"none"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20 0h40v40H20Zm0 0",
  style: {"stroke":"none","fill-rule":"nonzero","fill":"#fff","fill-opacity":"1"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M40 0h20v40H40Zm0 0",
  style: {"stroke":"none","fill-rule":"nonzero","fill":"#ce2b37","fill-opacity":"1"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }